import { rem } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.section`
  border-top: ${rem(1)} solid ${({ theme }) => theme.colors.border.secondary};
`;
